import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
const unwrapComposeFlipped = () => a => b => x => b(a(x));
const unsafeFromJust = v => {
  if (v.tag === "Just") { return v._1; }
  $runtime.fail();
};
const unsafeIndex = arr => {
  const $0 = Data$dArray.index(arr);
  return x => {
    const $1 = $0(x);
    if ($1.tag === "Just") { return $1._1; }
    $runtime.fail();
  };
};
const splitListEvery = n => v => {
  if (v.tag === "Nil") { return Data$dList$dTypes.Nil; }
  const x = Data$dArray.fromFoldableImpl(Data$dList$dTypes.foldableList.foldr)(Data$dList.take(n)(v));
  if (Data$dFoldable.foldlArray(c => v$1 => 1 + c | 0)(0)(x) === n) { return Data$dList$dTypes.$List("Cons", x, splitListEvery(n)(Data$dList.drop(n)(v))); }
  return Data$dList$dTypes.Nil;
};
const splitEvery = nVal => array => {
  if (nVal < 1) { return []; }
  return Data$dArray.fromFoldableImpl(Data$dList$dTypes.foldableList.foldr)(splitListEvery(nVal)(Data$dArray.toUnfoldable(Data$dList$dTypes.unfoldableList)(array)));
};
const targetSourcesEvery = nVal => array => {
  if (nVal < 1) { return []; }
  return Data$dFunctor.arrayMap(arr => Data$dTuple.$Tuple(
    (() => {
      const $0 = Data$dArray.index(arr)(arr.length - 1 | 0);
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    })(),
    (() => {
      const $0 = Data$dArray.init(arr);
      if ($0.tag === "Nothing") { return []; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    })()
  ))(splitEvery(nVal)(array));
};
const splitAt = num => arr => Data$dTuple.$Tuple(num < 1 ? [] : Data$dArray.slice(0)(num)(arr), num < 1 ? arr : Data$dArray.slice(num)(arr.length)(arr));
const ppArray = dictShow => array => "[\n" + Data$dFoldable.foldlArray(v => x => {
  if (v.init) { return {init: false, acc: x}; }
  return {init: false, acc: v.acc + ",\n\n" + x};
})({init: true, acc: ""})(Data$dFunctor.arrayMap(dictShow.show)(array)).acc + "\n]";
const partitionTuple = predicate => arr => {
  const $0 = Data$dArray.partition(predicate)(arr);
  return Data$dTuple.$Tuple($0.yes, $0.no);
};
const getW = () => o => acc => acc(o);
const fromW = () => b => a => b(a);
export {fromW, getW, partitionTuple, ppArray, splitAt, splitEvery, splitListEvery, targetSourcesEvery, unsafeFromJust, unsafeIndex, unwrapComposeFlipped};
